import { render, staticRenderFns } from "./ReportPurchaseGeneral.vue?vue&type=template&id=6489f5a4&scoped=true"
import script from "./ReportPurchaseGeneral.vue?vue&type=script&lang=js"
export * from "./ReportPurchaseGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6489f5a4",
  null
  
)

export default component.exports